<template>
	<v-container fluid class="pb-2 pt-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0">
						<v-row class="d-flex justify-space-between pb-0 pt-0">
							<v-col>
								<v-card-title class="justify-left align-center pa-2 pb-0 pt-0">
									{{ $t('titles.registrated') }}</v-card-title
								>
							</v-col>
							<v-col v-if="canEdit" class="d-flex justify-end align-center pa-2 pb-0 pt-0">
								<v-btn color="basicButton" class="mr-3" @click="addNewCandidateAndRegistration()">
									{{ $t('buttons.newCandidateAndRegistration') }}
									<v-icon small class="ml-2">fas fa-user-plus</v-icon>
								</v-btn>
								<v-btn color="basicButton" @click="addCandidateManual()">
									{{ $t('buttons.manuallyEnroll') }}
									<v-icon small class="ml-2">fas fa-user-plus</v-icon>
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0">
								<TheTable
									:additional-filters="candidatesRegistrationsTable.additionalFilters"
									:default-sort="candidatesRegistrationsTable.defaultSort"
									:excel="false"
									:show-pagination="false"
									:fields="candidatesRegistrationsTable.headers"
									:header-selection-key="'registrations-candidates-headers'"
									:height="candidatesRegistrationsTable.height"
									:total-records="candidatesRegistrationsTable.total"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr v-for="(item, key) in candidatesRegistrationsTable.items" :key="key">
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('rbr')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
											@click="
												addPaymentContract(
													item.id,
													item.first_name + ' ' + item.last_name,
													item.payment_contract_used_item_id,
													item.candidate_id
												)
											"
										>
											{{ key + 1 }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('first_name')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
											@click="
												addPaymentContract(
													item.id,
													item.first_name + ' ' + item.last_name,
													item.payment_contract_used_item_id,
													item.candidate_id
												)
											"
										>
											{{ item.candidate_id ? item.candidate.first_name : item.first_name }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('last_name')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
											@click="
												addPaymentContract(
													item.id,
													item.first_name + ' ' + item.last_name,
													item.payment_contract_used_item_id,
													item.candidate_id
												)
											"
										>
											{{ item.candidate_id ? item.candidate.last_name : item.last_name }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('email')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
											@click="
												addPaymentContract(
													item.id,
													item.first_name + ' ' + item.last_name,
													item.payment_contract_used_item_id,
													item.candidate_id
												)
											"
										>
											{{ item.candidate_id ? item.candidate.email : item.email }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('phone')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
											@click="
												addPaymentContract(
													item.id,
													item.first_name + ' ' + item.last_name,
													item.payment_contract_used_item_id,
													item.candidate_id
												)
											"
										>
											{{ item.candidate_id ? item.candidate.phone : item.phone }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('partner_id')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
											@click="
												addPaymentContract(
													item.id,
													item.first_name + ' ' + item.last_name,
													item.payment_contract_used_item_id,
													item.candidate_id
												)
											"
										>
											{{
												item.candidate_id
													? item.candidate.partner_id
														? item.candidate.partner.name
														: '-'
													: item.partner_id
													? item.partner.name
													: '-'
											}}
										</td>
										<td
											v-if="
												candidatesRegistrationsTable.selectedHeaders.includes('login_type_id')
											"
											@click="redirectClick(item.id, false)"
										>
											{{ item.login_type_id ? item.login_type.name : '' }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('loyalty_card')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
											@click="
												addPaymentContract(
													item.id,
													item.first_name + ' ' + item.last_name,
													item.payment_contract_used_item_id,
													item.candidate_id
												)
											"
										>
											{{ item.candidate ? item.candidate.loyalty_card : '' }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('note')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
										>
											{{ item.note }}
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('notified')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
										>
											<v-icon v-if="item.notified" small>fa-check</v-icon>
										</td>
										<td
											v-if="candidatesRegistrationsTable.selectedHeaders.includes('passed')"
											:class="{
												'red-text': item.payment_contract_used_item_id == null,
												'cursor-pointer2': item.payment_contract_used_item_id == null,
											}"
										>
											<v-icon v-if="item.testimonial_number != null" small>fa-check</v-icon>
										</td>
										<td v-if="canEdit">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														v-bind="attrs"
														@click="disenrollCandidate(item.id, item.manual_enrollment)"
														v-on="on"
														:disabled="item.passed == 1"
													>
														<v-icon small>fas fa-user-minus</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.switchToPreregistration') }}</span>
											</v-tooltip>
										</td>
										<td v-if="canEdit && item.testimonial_number == null">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														color="basicButton"
														v-bind="attrs"
														@click="
															candidatePassedExam(
																item.id,
																item.first_name + ' ' + item.last_name,
																false
															)
														"
														v-on="on"
													>
														{{ $t('buttons.passed') }}
													</v-btn>
												</template>
												<span>{{ $t('tooltips.passed') }}</span>
											</v-tooltip>
										</td>
										<td v-if="canEdit && item.testimonial_number != null">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														color="basicButton"
														v-bind="attrs"
														@click="
															deleteTestimonial(
																item.id,
																item.first_name + ' ' + item.last_name
															)
														"
														v-on="on"
													>
														{{ $t('buttons.deleteTestimonial') }}
													</v-btn>
												</template>
												<span>{{ $t('tooltips.deleteTestimonial') }}</span>
											</v-tooltip>
										</td>
										<td v-if="canEdit && item.testimonial_number != null">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														v-bind="attrs"
														@click="
															candidatePassedExam(
																item.id,
																item.first_name + ' ' + item.last_name,
																true,
																item.testimonial_number
															)
														"
														v-on="on"
													>
														<v-icon small>fas fa-circle-question</v-icon>
													</v-btn>
												</template>
												<span>{{
													$t('tooltips.testimonialNumber') + item.testimonial_number
												}}</span>
											</v-tooltip>
										</td>
										<td v-if="item.payment_contract_used_item_id != null">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														v-bind="attrs"
														@click="
															openPaymentContract(
																item.payment_contract_used_item.payment_contract_id
															)
														"
														v-on="on"
													>
														<v-icon small>fa-arrow-circle-right</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openPaymentContract') }}</span>
											</v-tooltip>
										</td>
										<td v-else>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														v-bind="attrs"
														@click="createPaymentContract(item.candidate_id)"
														v-on="on"
													>
														<v-icon small>fa-plus</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.createPaymentContract') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
						<v-row v-if="showModal">
							<v-col>
								<Modal :show-modal="showModal">
									<ManualRegistration @close="closeModal"></ManualRegistration>
								</Modal>
							</v-col>
						</v-row>
						<v-row v-if="showAddContractModal">
							<v-col>
								<Modal :show-modal="showAddContractModal">
									<CandidatePaymentContract
										:addPaymentContractAfterEnrollment="true"
										:candidateFullName="candidateFullName"
										:preregistrationId="preregistrationId"
										:candidateId="candidateId"
										@close="closeModal"
									></CandidatePaymentContract>
								</Modal>
							</v-col>
						</v-row>
						<v-row v-if="showModalPassedExam">
							<v-col>
								<Modal :show-modal="showModalPassedExam">
									<CandidatePassedExam
										:inViewMode="inViewMode"
										:readonlyTestimonialNumber="readonlyTestimonialNumber"
										:candidateFullName="candidateFullName"
										:preregistrationId="preregistrationId"
										@close="closeModal"
									></CandidatePassedExam>
								</Modal>
							</v-col>
						</v-row>
						<v-row v-if="showNewCandidateModal">
							<v-col>
								<Modal :show-modal="showNewCandidateModal">
									<NewCandidate
										:newCandidate="{}"
										:registration="true"
										:inEditMode="true"
										@close="closeModal"
									></NewCandidate>
								</Modal>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Modal from '../../trinkets/Modal';
import ManualRegistration from './ManualRegistration';
import CandidatePaymentContract from './CandidatePaymentContract';
import CandidatePassedExam from './CandidatePassedExam';
import NewCandidate from './NewCandidate';

export default {
	name: 'CandidatesRegistrations',
	components: { TheTable, Modal, ManualRegistration, CandidatePaymentContract, CandidatePassedExam, NewCandidate },
	props: {
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	emits: ['reloadParticipants'],
	data: function () {
		return {
			candidatesRegistrationsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.rbr'),
						value: 'rbr',
						type: '',
						sortable: false,
						width: '50px',
						allowFilter: false,
					},
					{
						text: this.$t('fields.firstName'),
						value: 'first_name',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.lastName'),
						value: 'last_name',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.email'), value: 'email', type: '', sortable: false, allowFilter: true },
					{ text: this.$t('fields.phone'), value: 'phone', type: '', sortable: false, allowFilter: true },
					{
						text: this.$t('fields.company'),
						value: 'partner_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.loginType'),
						value: 'login_type_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.loyaltyCard'),
						value: 'loyalty_card',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.note'), value: 'note', type: '', sortable: false, allowFilter: true },

					{
						text: this.$t('fields.notified'),
						value: 'notified',
						type: '',
						width: '100px',
						sortable: false,
						allowFilter: false,
					},
					{
						text: this.$t('fields.passed'),
						value: 'passed',
						type: '',
						width: '100px',
						sortable: false,
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
					{ text: '', value: 'action2', type: '', sortable: false, width: '100px', allowFilter: false },
					{ text: '', value: 'action3', type: '', sortable: false, width: '50px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			showModal: false,
			showModalPassedExam: false,
			showAddContractModal: false,
			showNewCandidateModal: false,
			preregistrationId: null,
			candidateFullName: null,
			candidateId: null,
			inViewMode: false,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.candidatesRegistrationsTable.selectedHeaders = headers;
		},
		addCandidateManual() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			this.showAddContractModal = false;
			this.showModalPassedExam = false;
			this.showNewCandidateModal = false;
			this.inViewMode = false;
			this.preregistrationId = null;
			this.candidateFullName = null;
		},
		candidatePassedExam(preregistration_id, candidateFullName, viewMode, number = 0) {
			this.inViewMode = viewMode;
			this.readonlyTestimonialNumber = number;
			this.showModalPassedExam = true;
			this.preregistrationId = preregistration_id;
			this.candidateFullName = candidateFullName;
		},
		addPaymentContract(preregistration_id, candidateFullName, used_item_id, candidateId) {
			if (used_item_id == null) {
				this.showAddContractModal = true;
				this.preregistrationId = preregistration_id;
				this.candidateFullName = candidateFullName;
				this.candidateId = candidateId;
			}
		},
		addNewCandidateAndRegistration() {
			this.showNewCandidateModal = true;
		},
		openPaymentContract(id) {
			if (!(parseInt(id, 10) > 0)) {
				this.$alert(this.$t('alerts.basicError'));
				return;
			}
			this.$router.push('/payment-contracts/' + id);
		},
		createPaymentContract(candidateId) {
			this.$router.push({
				name: 'paymentContract',
				params: {
					id: 0,
					candidateId: candidateId,
					contractType: 'candidate',
					plannedCourseId: this.$route.params.id,
				},
			});
		},
		deleteTestimonial(id, candidateFullName) {
			let vm = this;
			this.$verify(
				this.$t('alerts.deleteTestimonialQuestion').replace('%candidate%', candidateFullName),
				(result) => {
					if (result) {
						vm.$APICall(
							'delete',
							'preregistrations/passed/' + id + '/delete',
							{ planned_course_id: this.$route.params.id, id: id },
							(data, success) => {
								if (success) {
									vm.$notify(vm.$t('alerts.basicDelete'));
									vm.$modalBus.$emit('reloadCandidatesRegistrations');
								} else {
									vm.$alert(vm.$t('alerts.basicError'));
								}
								this.$emit('close');
							}
						);
					}
				}
			);
		},
		disenrollCandidate(id, manualEnrollment) {
			if (manualEnrollment) {
				this.$verify(this.$t('alerts.disenrollmentManuallyAddedCandidate'), (result) => {
					if (result) {
						this.disenrollment(id);
					} else {
						this.deleteRegistrationOfManuallyAddedCandidate(id);
					}
				});
			} else {
				this.disenrollment(id);
			}
		},
		disenrollment(id) {
			let vm = this;
			this.$APICall(
				'put',
				'preregistrations/enrollment/' + id,
				{ enrollment: false, user_id: this.$myStore.state.user.id, planned_course_id: this.$route.params.id },
				(data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicUpdate'));
						vm.reloadData(vm.candidatesRegistrationsTable.lastRequest);
						vm.$modalBus.$emit('reloadPlannedCourse');
						vm.$modalBus.$emit('reloadCandidatesPreregistrations');
						vm.$modalBus.$emit('reloadParticipants');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				}
			);
		},
		deleteRegistrationOfManuallyAddedCandidate(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deleteRegistrationOfManuallyAddedCandidate'), (result) => {
				if (result) {
					this.$APICall(
						'delete',
						'preregistrations/' + id + '/delete',
						{ user_id: this.$myStore.state.user.id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
								vm.reloadData(vm.candidatesRegistrationsTable.lastRequest);
								vm.$modalBus.$emit('reloadParticipants');
								vm.$modalBus.$emit('reloadPlannedCourse');
								vm.$modalBus.$emit('reloadCandidatesPreregistrations');
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
		reloadData(request) {
			this.candidatesRegistrationsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'registrations-candidates/' + this.plannedCourseId,
				request,
				(data, success) => {
					if (success) {
						vm.candidatesRegistrationsTable.items = data.items;
						vm.candidatesRegistrationsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.candidatesRegistrationsTable.height = '500px';
		},
	},
	mounted() {
		let vm = this;
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadCandidatesRegistrations', () => {
			vm.reloadData(vm.candidatesRegistrationsTable.lastRequest);
		});

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped>
.red-text {
	color: #ff474c;
}

.cursor-pointer2 {
	cursor: pointer;
}
</style>
